<div class="app-export-structure" *transloco="let t">
  <app-language-selection
    [activeLanguageId]="activeLanguageId"
  ></app-language-selection>
  <app-customize-toggle
    (exportToggleHandler)="onToggleChanged($event)"
  ></app-customize-toggle>
  <div *ngIf="isExportStruktureVisible" class="app-export-structure--open">
    <app-folder-structure></app-folder-structure>
    <app-file-structure></app-file-structure>
    <mat-checkbox
      id="app-export-structure_checkbox_remember"
      [checked]="rememberSettings"
      (change)="onRememberSettings($event)"
      color="primary"
    >
      <span class="app-export-structure__checkbox-text">{{
        t("step3.eh-mydocuments-step3-export-remember-settings")
      }}</span>
    </mat-checkbox>
  </div>
</div>
